/**
 * Lock-in countdown helpers (align with backend calendar-day lock-in using UTC date boundaries).
 */

/** @param {string | undefined | null} unlockIso */
export function lockInCalendarDaysRemaining(unlockIso) {
  if (unlockIso == null || unlockIso === "") return null;
  const end = new Date(unlockIso);
  if (Number.isNaN(end.getTime())) return null;
  const now = new Date();
  const startUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const endUtc = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());
  const diffMs = endUtc - startUtc;
  return Math.max(0, Math.ceil(diffMs / 86400000));
}

/**
 * Human-readable lock-in remaining (calendar days until unlock date, inclusive of unlock day as "ends today").
 */
export function formatLockInCountdownLabel(unlockIso) {
  const d = lockInCalendarDaysRemaining(unlockIso);
  if (d == null) return "";
  if (d === 0) return "Lock-in ends today — redemptions unlock after the lock-in window.";
  if (d === 1) return "1 calendar day remaining in lock-in.";
  return `${d} calendar days remaining in lock-in.`;
}
